// MUI Components
import MuiButton from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import SupervisedUserCircleIcon from '@mui/icons-material/SupervisedUserCircleOutlined';

// HELPERS
import i18n from "@helpers/i18n";

const ActiveAdvisorButton = props => {
  const {
    advisor,
    onCurrentAssistantAdvisorClick
  } = props;

  return (
    <MuiButton
      variant="contained"
      onClick={onCurrentAssistantAdvisorClick}
      sx={{
        position: "fixed",
        top: 10,
        right: 220,
        minHeight: "40px",
        flexDirection: "row",
        justifyContent: "flex-start",
        width: "200px",
        boxShadow: '0px 2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)',
        border: '1px solid #d2dbe8',
        padding: '5px 10px',
        backgroundColor: 'primary.light',
        "&:hover": {
          backgroundColor: 'primary.light',
          boxShadow: '0px 2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)'
        },
        borderRadius: "8px"
      }}
    >
      <SupervisedUserCircleIcon
        fontSize="medium"
        sx={{
          p: 0,
          mr: 0.625,
          height: 25,
          width: 25,
          color: "primary.light",
          backgroundColor: "#a7b1d6",
          borderRadius: "50%"
        }}
      />
      <Typography
        variant="button"
        fontFamily="Roboto"
        sx={{
          fontSize: "12px",
          lineHeight: "15px",
          // ml: 0,
          color: "#000",
          whiteSpace: "nowrap",
          maxWidth: 150,
          textAlign: "start",
          overflow: "hidden",
          textOverflow: "ellipsis"
        }}
        >
          {advisor?.firstName} {advisor?.lastName}
          <em
            style={{
              display: "block",
              fontStyle: "normal",
              fontSize: "10px",
              color: "#999",
              lineHeight: "11px",
              textAlign: "start",
            }}
            >
              {i18n("cob", "active_advisor")}
            </em>
      </Typography>
    </MuiButton>
  );
};

export default ActiveAdvisorButton;
